<template>
  <div class="card-goods" v-if="goods.goodsName">
    <div class="goods-item">
      <div class="item-text">{{ goods.goodsName }}</div>
      <div class="item-price" v-if="!fromIntegral">¥{{ goods.goodsPrice }}</div>
      <div class="item-price" v-else>{{ goods.creditVal }}{{ integralName }}</div>
    </div>
    <img :src="goodsIcon" class="goods-icon" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { defaultGoodsIcon } from '@/pages/config'

export default {
  name: 'CardGoods',
  props: {
    fromIntegral: Boolean,
    goods: {}
  },
  computed: {
    ...mapGetters('integral/index', ['integralName']),
    goodsIcon() {
      return this.goods.goodsIcon || defaultGoodsIcon
    }
  }
}
</script>

<style lang="scss" scoped>
.card-goods {
  display: flex;
  justify-content: space-between;
  padding: 0.38rem 0.48rem;
  background-color: #fff;
  .goods-icon {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 0.04rem;
    object-fit: contain;
  }
  .goods-item {
    flex: 1;
    text-align: left;
    font-weight: bold;
    padding-right: 0.4rem;
    .item-text {
      font-size: 0.32rem;
      line-height: 0.34rem;
      color: #000000;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .item-price {
      font-size: 0.36rem;
      color: #00b25a;
      line-height: 0.44rem;
      margin-top: 0.24rem;
    }
  }
}
</style>
